__turbopack_context__.v({
  "addButtonContainer": "createLists-module-scss-module__5LCLsa__addButtonContainer",
  "deleteButton": "createLists-module-scss-module__5LCLsa__deleteButton",
  "fieldsWrapper": "createLists-module-scss-module__5LCLsa__fieldsWrapper",
  "formLabel": "createLists-module-scss-module__5LCLsa__formLabel",
  "listItem": "createLists-module-scss-module__5LCLsa__listItem",
  "nameField": "createLists-module-scss-module__5LCLsa__nameField",
  "tagsContainer": "createLists-module-scss-module__5LCLsa__tagsContainer",
});
